Ext.define('SA.GeoJson', {
    singleton: true,

    createEmptyFeatureCollection() {
        return turf.featureCollection([]);
    },

    getCoordinate(point) {
        return SA.VectorMapCoordinate.fromLngLat(turf.getCoord(point));
    }
});